import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getRenologDevices = async (projectId, doSync) => {
  const apiPath = doSync
    ? `projects/${projectId}/renolog/devices?doSync=true`
    : `projects/${projectId}/renolog/devices`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
